<app-modal
  [open]="open()"
  [title]="'LOCALE_SELECTOR_TITLE'"
  [showCancel]="false"
  [showConfirm]="false"
  (cancelled)="closed.emit()"
>
  <div class="locale-zones">
    @for (zone of zones(); track zone.key) {
      <section class="locale-zone">
        <h3 class="locale-zone-title">{{ zone.titleKey | translate }}</h3>
        <ul class="locale-grid" role="listbox">
          @for (option of zone.options; track option.locale) {
            <li [id]="'locale-' + option.locale">
              <button
                class="locale-card"
                role="option"
                type="button"
                [class.selected]="isSelected(option)"
                [attr.aria-selected]="isSelected(option)"
                (click)="onLocaleSelected(option)"
              >
                <app-icon class="locale-pin" path="assets/img/location-pin.svg" [size]="16" />
                <span class="locale-country">{{ option.country }}</span>
                <span class="locale-language">{{ option.languageLabel }}</span>
              </button>
            </li>
          }
        </ul>
      </section>
    }
  </div>
</app-modal>
